import gql from 'graphql-tag';

import type { EntityComplianceData } from 'src/data/compliance';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BLOG_DRAFT_COMPLIANCE } from './schema';

const QUERY = gql`
  query ComplianceForBlogDraft($id: ID!) {
    complianceForBlogPostDraft(id: $id) {
      ...BlogDraftCompliance
    }
  }
  ${FRAGMENT_BLOG_DRAFT_COMPLIANCE}
`;

export const queryComplianceForBlogDraft = async (id: ID) => {
  const variables = { id };

  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  return getSingleProp<EntityComplianceData>(result.data);
};
